// Copyright: IQGeo Limited 2010-2019
import L from 'leaflet';
import myw from 'myWorld/base/core';
import Promise from 'bluebird';

myw.KmzLayer = myw.KmlLayer.extend({
    onAdd(map) {
        this.options.onError = message => {
            this.fire('invalid');
        };

        if (this._urlToLoad) {
            this.addKMZ(this._urlToLoad, this.options, this.options.async);
            delete this._urlToLoad;
        }
        this.datasource.system.recordDataAccess(
            this.datasource.database.applicationName,
            `layer.${this.layerDef.name}`
        );
        return L.KML.prototype.onAdd.call(this, map);
    },

    addKMZ: function(url, options, async) {
        var _this = this;
        var cb = function(kml) {
            _this._addKMZ(kml);
        };
        this.loadXML(url, cb, options, async);
    },

    _addKMZ: function(xml) {
        //  Translate any relative URLs to use myWorld KMZ files
        const hrefs = xml.getElementsByTagName('href');
        let baseUrl = this.datasource.options.baseUrl;
        if (baseUrl.slice(-1) !== '/') baseUrl += '/';
        Promise.each(hrefs, async node => {
            if (!/^http[s]?:\/\//.test(node.innerHTML)) {
                node.innerHTML = await myw.app.system.getUrlForKmz(this.layerDef, node.innerHTML);
            }
        }).then(() => myw.KmlLayer.prototype._addKML.call(this, xml));
    }
});
